module.exports = __webpack_public_path__ + "static/media/order-success.1ad37124.svg";